import { Navigate } from "react-router-dom";
import { useAuth } from "./authContext";

const PermissionRoute = ({ permissionKey = "", children }) => {
  const { isAllowed } = useAuth();

  if (!isAllowed(permissionKey)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default PermissionRoute;